import type { OwaPalette } from "owa-theme-shared";

// documentation for adding colors: https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/4626/Colors
export const DARK_THEME_NEUTRALS = {
    black: "#FFFFFF",
    blackTranslucent50: "rgba(255, 255, 255, 0.5)",
    blackTranslucent40: "rgba(255, 255, 255, 0.4)",
    blackTranslucent20: "rgba(255, 255, 255, 0.2)",
    blackTranslucent10: "rgba(255, 255, 255, 0.1)",
    white: "#000000",
    whiteTranslucent40: "rgba(0, 0, 0, 0.4)",
    whiteTranslucent50: "rgba(0, 0, 0, 0.5)",
    whiteTranslucent65: "rgba(0, 0, 0, 0.65)",
    whiteTranslucent70: "rgba(0, 0, 0, 0.7)",
    whiteTranslucent90: "rgba(0, 0, 0, 0.9)",
    neutralDark: "#FFFFFF",
    neutralPrimary: "#D6D6D6",
    neutralPrimaryAlt: "#ADADAD",
    neutralPrimarySurface: "#292929",
    neutralSecondary: "#858585",
    neutralSecondaryAlt: "#979593",
    neutralSecondarySurface: "#141414",
    neutralTertiary: "#666666",
    neutralTertiaryAlt: "#525252",
    neutralTertiarySurface: "#0A0A0A",
    neutralQuaternary: "#2E2E2E",
    neutralLight: "#3D3D3D",
    neutralQuaternaryAlt: "#333333",
    neutralLighter: "#141414",
    neutralLighterAlt: "#1F1F1F",
    redDark: "#B94D52",
    green20: "#6BA02B",
    purple: "#B65FC2",
    suiteuxNeutralLight: "#555555",
    suiteuxNeutralSecondary: "#FFFFFF",
    
    flaggedMessage: "#242100",
    richUserContentBackground: "#EBEBEB",
    composeNeutralBackground: "#242424",
    composeNeutralLighterBackground: "#fff",
    readingPaneCardBorder: "#000000",
    readingPaneCardFocusBorder: "#D1D1D1",
    
    oobeWhite: "#ffffff",
    oobePrimary: "#0078d4",
    oobeDarkAlt: "#106EBE",
    oobeThemeLighter: "#DEECF9",
    
    cardStyleWhite: "#484644",
    freeBusyAwayColor: "#F500D8",
    
    // https://www.figma.com/file/c5TF4jwqrpms2PSQH3EXtFTc/Fluent-Color?node-id=3301%3A115
    messageWebWarning: "#4d3a0c",
    messageMobileWarningPrimary: "#ffd335",
    messageMobileWarningShade20: "#ffdd15",
    messageMobileWarningShade30: "#ffdd87",
    messageMobileWarningTint30: "#4d3a0c",
    messageMobileWarningTint40: "#291F07",
    communicationBlueWebPrimary: "#2899f5",
    messageMobileDangerPrimary: "#e83a3a",
    messageMobileDangerShade20: "#ee6666",
    messageMobileDangerTint30: "#461111",
    messageMobileDangerTint40: "#250909",
    messageMobileSuccessPrimary: "#0eb244",
    presenceAway: "#f8d22a",
    presenceDoNotDisturb: "#d74553",
    presenceOnline: "#92c353",
    presenceInvisible: "#979593",
    presenceOOF: "#e959d9",
    
    // Addison component picker button gradient
    addisonComponentButtonGradientStart: "#f7f0ff",
    addisonComponentButtonGradientEnd: "#e9dfff",
    
    storageCritialStateColor: "#E37D80",
    storageCritialStateHoverColor: "#DC5E62",
    storageNearingStateColor: "#F2C661",
    storageNearingStateHoverColor: "#EFB839",
    storageUsageBarBorder: "#292929",
    
    bizBarRed: "#442726",
    msqOneDrive: "#637CEF",
    msqTeams: "#9A44FC",
    msqOutlook: "#E3008C",
    msqWindows: "#D64400",
    msqEdge: "#1BA756",
    msqLoop: "#2AA0A4",
    msqDesigner: "#9373C0",
    
    //Places Explore colors
    placesPrimary: "#583DFF",
    
    // Places linear gradient section
    placesLightBlueSolidColor: "#28DFF8",
    placesNavyBlueSolidColor: "#209DF5",
    
    // Places theme colors
    placesBackgroundColorPink: "rgba(255,116,243,.2)",
    placesBackgroundColorPurple: "rgba(205,112,255,.2)",
    placesBackgroundColorLightBlue: "rgba(39,213,248,.2)",
    placesBackgroundColorNavy: "rgba(9,99,121,.2)",
    
    // Places theme colors used in workspaces https://www.figma.com/file/3IJc3nTEB1EeHUKZjReFD8/Reserve-a-desk
    // referred to https://react.fluentui.dev/?path=/docs/theme-color--page for cross theme tokens
    placesBluePrimary: "#5caae5",
    placesBlueTint40: "#004377",
    placesLightBackground3: "#3d3d3d",
    placesLightBlueBackground: "#082338",
    placesNeutralGrey92: "#000000",
    
    placesBlueGradient1: "#2A4FFE",
    placesBlueGradient2: "#6530FC",
    placesBlueBackground1: "#E1E6FC",
    placesBlueForeground1: "#637CEF",
    placesBlueBorder1: "#2510BC",
    placesCornflowerForeground1: "#444791",
    placesCornflowerForeground2: "#93A4F4",
    
    placesRemoteUnspecifiedBackground1: "#4D4D4D",
    placesRemoteUnspecifiedForeground1: "#CCCCCC",
    placesOOFBackground1: "#6D2064",
    placesOOFForeground1: "#EDBBE7",
    
    placesRemote1: "#182047",
    placesRemoteBorder1: "#778DF1",
    
    // Colors for floorMap in Places https://www.figma.com/file/h7UJrieBtHnGAimIh8BjVu/Modernize-improvements
    neutralBackground6: "#333333",
    lilacBackground2: "#63276D",
    neutralForeground4: "#999999",
    neutralBackground2Pressed: "#141414",
    
    sharedLavenderTint10: "#8172EB",
    
    sharedCornflowerTint20: "#778DF1",
    sharedCornflowerTint30: "#93A4F4",
    sharedCornflowerTint50: "#E1E6FC",
    sharedCornflowerTint60: "#182047",
    sharedCornFlowerShade20: "#778DF1",
    
    placesPurpleOOFBackground1: "#F5DAF2",
    placesPurpleOOFForeground1: "#AF33A1",
    
    placesPurpleGradient1: "#6A11CB",
    
    boxShadowPrimary: "rgba(0, 0, 0, 0.28)",
    boxShadowSecondary: "rgba(0, 0, 0, 0.24)",
    
    // Places brand colors (custom tokens to avoid overriding Fluent tokens)
    // https://www.figma.com/design/1E735mCHqzhgdZUjRnOYWM/TPX-UI-Kit?node-id=10703-6096
    places70: "#C5C1FF",
    places80: "#5B41FF",
    places80Pressed: "#4F28C1",
    places160: "#333240",
    
    placesColorBackground2: "#1F0F2E",
    placesColorBackground2Hover: "#3D1A77",
    placesColorBackground2Pressed: "#050107",
    
    placesColorForeground2: "#A79EFF", // Places 130
    placesColorForeground2Hover: "#B5B0FF", // Places 140
    placesColorForeground2Pressed: "#E4E2FF", // Places 160
    placesColorForeground2Selected: "#B5B0FF", // Places 140
    
    placesColorStroke2: "#47209C", // Places 50
    placesColorStroke2Hover: "#47209C", // Places 50
    placesColorStroke2Pressed: "#311555", // Places 30
    
    placesColorBrandForeground1: "#7B69FF", // Places 100
    
    placesPresenceAvailable: "#0EB244",
    
    // Availability colors used by Places surfaces (Space Finder map, etc.)
    placesColorAvailableBackground: "#063B06",
    placesColorAvailableBackgroundHover: "#54B054",
    placesColorAvailableBackgroundPressed: "#9FD89F",
    placesColorAvailableBackgroundSelected: "#54B054",
    placesColorAvailableStroke: "#13A10E",
    placesColorAvailableStrokeHover: "#0B6A0B",
    placesColorAvailableStrokePressed: "#0B6A0B",
    placesColorAvailableStrokeSelected: "#13A10E",
    placesColorUnavailableBackground: "#5C5C5C",
    placesColorUnavailableBackgroundHover: "#999999",
    placesColorUnavailableBackgroundPressed: "#D6D6D6",
    placesColorUnavailableBackgroundSelected: "#ADADAD",
    placesColorUnavailableStroke: "#666666",
    placesColorUnavailableStrokeHover: "#757575",
    placesColorUnavailableStrokePressed: "#6B6B6B",
    placesColorUnavailableStrokeSelected: "#6B6B6B",
    
    paneLighterBackground: "#212121",
    
    copilotGradientStart: "#BA6DF1",
    copilotGradientEnd: "#4B9DF5",
    copilotChatBackground: "#242424",
    
    copilotSelectionBackground: "#7385FF66",
    copilotSelectionBorder: "#7385FF",
    
    placesExploreGradient1: "#23232F",
    placesExploreGradient2: "#3B2E4A",
    
    // TODO: These have always been the same values as light mode
    // Should they be different?
    yellow: "#ffb900",
    orange: "#d83b01",
    red: "#e81123",
    blue: "#0078d4",
    green: "107c10",
    
    // Colors used in calendar event print, which are the same across themes.
    eventPrintColorPrimary: "#242424",
    eventPrintColorSecondary: "#605e5c",
    eventPrintColorBackground: "#ffffff",
    
    sharedLightGreenTint50: "#CEF0CD",
    sharedDarkGreenTint30: "#4DA64D",
    
    // Colors for home page in Bookings
    bookingsTeal10: "#004A5A",
    bookingsTeal20: "#2E9AB3",
    bookingsTeal50: "#89CEE1",
    bookingsTeal80: "#89CEE1",
    bookingsAccentGreen10: "#052505",
    bookingsAccentGreen20: "#107C10",
    bookingsForegroundTeal60: "#263B50",
    bookingsForegroundTeal80: "#89CEE1",
    bookingsNeutralForeground1: "#FFFFFF",
    bookingsNeutralForeground2: "#E0E0E0",
    bookingsNeutralForeground4: "#E0E0E0",
    bookingsRedForeground1: "#E37D80",
    bookingsNeutralStroke1: "#616161",
    bookingsNeutralBackground1: "#333333",
    bookingsGreenConsistent: "#0EB244",
    bookingsGrayConsistent: "#424242",
    bookingsGrayBackground1: "#141414",
    bookingsGrayLightBackground1: "#F3F2F1",
    bookingsSilverSandBorder1: "#C8C6C4",
    bookingsDefaultRed: "#E37D80",
    bookingsWarning1: "#FFF9F5",
    bookingsWarning2: "#FDCFB4",
    bookingsWarning3: "#8A3707",
    bookingsDanger1: "#FDF6F6",
    bookingsDanger2: "#F1BBBC",
    bookingsDanger3: "#A80000",
    bookingsBlueForeground: "#007F9C",
    
    // Colors for floor map in Places. Figma: https://www.figma.com/design/Wgido27TpI2QHr8ckeNl3Z/Places-Map-%26-Finder-Master
    mapBackgroundFloor: "#101010",
    mapBackgroundFacilities: "#101010",
    mapBackgroundWall: "#0D0D0D",
    mapBackgroundArea: "#1B1B1B",
    mapBackgroundUnavailable: "#3D3870",
    mapBackgroundFree: "#6F68D6",
    mapStrokeFloorAndWall: "#99A0C3",
    pinAvailableTextFill: "#B5B0FF",
    pinUnavailableTextFill: "#D6D6D6",
    
    placesBlueTint50: "#273D51",
    placesLightBlueShade20: "#65ADE5",
    placesCyanTint50: "#304D57",
    placesCyanShade10: "#A4DEEB",
    placesCyanShade20: "#56BFD7",
    placesNeutralForeground2: "#FFFFFF",
    placesSeaformShade20: "#A7E3A5",
    placesSeaformShade30: "#5EC75A",
    placesLightGreenShade20: "#A7E3A5",
    
    // Eventify/Workplace Events specific colors
    eventifySurveyStatusIncompleteColor: "#806a1a",
    eventifySurveyStatusIncompleteBackground: "#fff2c3",
    eventifyClosedSurveyBannerBorder: "#ffd94e",
    eventifyClosedSurveyBannerColor: "#8f761e",
    eventifySurveyListItemBorder: "#d9d9d9",
    eventifySurveyStatusCompleteBackground: "#caead8",
    eventifySurveyStatusCompleteColor: "#37a660",
    eventifyEventPreviewColor: "#7a6519",
    eventifyEventCancelledBackground: "#f9d9d9",
    eventifyEventCancelledBorder: "#e87979",
    eventifyEventCancelledColor: "#a61b1b",
    
    // Gradient colors for the app background image
    appBackgroundGradientColor: "rgba(0,0,0,.5)",
    copilotAppBackgroundGradientColor: "rgba(0,0,0,.5)",
    
    //Colors for Copilot Flair on Calendar Surface
    copilotFlairColor1: "#464feb",
    copilotFlairColor2: "#47cffa",
    copilotFlairColor3: "#b47cf8",
    copilotFlairColor1Transparent: "rgba(70,79,235,0)",
    copilotFlairColor2Transparent: "rgba(71,207,250,0)",
    copilotFlairColor3Transparent: "rgba(180,124,248,0)",
    
    // Outlook custom colors for Fluent v9 components.
    // Figma: https://www.figma.com/design/DYS2ZPisghfHhw6N7u0Vtj/Outlook-web-variables?node-id=8609-2615&t=3gLSNnfOLDXbJ62W-1
    // Neutral colors
    customNeutralStrokeTransparent2: "#525252",
    customNeutralStrokeOnBackground1: "#999999",
    customNeutralStrokeOnBackground1Hover: "#A8A8A8",
    customNeutralStrokeOnBackground1Pressed: "#9E9E9E",
    // Colors for warning states
    colorStatusWarningForeground3: "#F98845",
    
    // Colors for Focus, Select, Hover, Flag, on Mail List Item
    customNeutralNonFocusBackground: "#3D3D3D",
    customYellowBackground: "#3A2F00",
    
    // Color for Message List calendar pill
    colorNeutralBackgroundInvertedTransparent4: "rgba(255, 255, 255, 0.05)",
    // Color for Message list marker pill
    colorNeutralBackgroundInvertedTransparent5: "rgba(255, 255, 255, 0.05)",
    
    //Often used in Icon Colors
    customActiveDangerRedForegroundHover1: "#EEACB2",
    customBlueForeground1: "#3595DE",
    customBlueForegroundDisabled: "rgba(53,149,222,.5)",
    customActiveBlueForegroundHover1: "#A9D3F2",
    customDangerForegroundDisabled: "rgba(220,98,109,.5)",
    customSuccessForegroundDisabled: "rgba(84,176,84,.5)",
    customWarningForegroundDisabled: "rgba(249,136,69,.5)",
    customPurpleForeground1Disabled: "rgba(218,126,208,.5)",
    
    // Calendar Work Hours border
    calendarWorkHoursBorder: "#6b6b6b",
    
    // Copilot theme creator experience colors
    // Copilot mesh gradient colors
    copilotThemeMeshColor1: "#b10606",
    copilotThemeMeshColor2: "#ffae52",
    copilotThemeMeshColor3: "#f05689",
    copilotThemeMeshColor4: "#e8a702",
    copilotThemeMeshColor5: "#51b36f",
    copilotThemeMeshColor6: "#0d91de",
    // UI colors
    copilotThemeWhite: "#ffffff",
    copilotThemeWhiteTranslucent: "rgba(0, 0, 0, 0.25)",
    
    // Copilot Event Importance
    copilotEventImportanceLowPrimary: "#92C353",
    copilotEventImportanceLowLight: "#393D1B",
    copilotEventImportanceMediumPrimary: "#FFC328",
    copilotEventImportanceMediumLight: "#291F07",
    copilotEventImportanceHighPrimary: "#F1707B",
    copilotEventImportanceHighLight: "#442726",
    
    // Big Hover Button Colors
    archiveBigHoverForeground: "#92c353",
    archiveBigHoverBackground: "#393d1b",
    deleteBigHoverForeground: "#f1707b",
    deleteBigHoverBackground: "#442726",
    
    // Attachment thumbnail
    attachmentThumbnailOverlay: "rgba(0, 0, 0, 0.7)",
    attachmentThumbnailOverlayHover: "rgba(0, 0, 0, 0.67)",
};

export const BASE_DARK_THEME_PALETTE: OwaPalette = {
    ...DARK_THEME_NEUTRALS,
    themeDarker: "#B4D6FA",
    themeDark: "#77B7F7",
    themeDarkAlt: "#62ABF5",
    themePrimary: "#479EF5",
    themeSecondary: "#2B88D8",
    themeTertiary: "#115EA3",
    themeLight: "#0A2E4A",
    themeLighter: "#082338",
    themeLighterAlt: "#061724",
    themeSecondarySurfaceSelected: "#0A2E4A",
    headerBackground: "#479EF5",
    headerBackgroundSearch: "#479EF5",
    headerBrandText: "#000000",
    headerTextIcons: "#000000",
    headerSearchBoxBackground: "rgba(33,32,33,0.7)",
    headerSearchBoxIcon: "#B4D6FA",
    headerSearchPlaceholderText: "#B4D6FA",
    headerSearchButtonBackground: "#479EF5",
    headerSearchButtonBackgroundHover: "#B4D6FA",
    headerSearchButtonIcon: "#000000",
    headerSearchFilters: "#479EF5",
    headerSearchFiltersHover: "#B4D6FA",
    headerButtonsBackground: "#479EF5",
    headerButtonsBackgroundHover: "#B4D6FA",
    headerButtonsBackgroundSearch: "#479EF5",
    headerButtonsBackgroundSearchHover: "#B4D6FA",
    headerBadgeBackground: "#B4D6FA",
    headerBadgeText: "#000000",
    headerSearchIcon: "#000000",
    searchBoxBackground: "rgba(33,32,33,0.7)",
    customBrandBackground3Hover: "#0C3B5E",
    customBrandBackgroundforSelected3: "#0A2E4A",
    customBrandBackground3Pressed: "#082338",
    customBrandBackgroundforSelected4: "#082338",
    customBrandBackground4Hover: "#0A2E4A",
    customBrandBackground4Pressed: "#06182A",
};
